import { render, staticRenderFns } from "./oral.vue?vue&type=template&id=0f880674&scoped=true"
import script from "./oral.vue?vue&type=script&lang=js"
export * from "./oral.vue?vue&type=script&lang=js"
import style0 from "./oral.vue?vue&type=style&index=0&id=0f880674&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f880674",
  null
  
)

export default component.exports